// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ValorServicosFranquias_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/valor_servicos_franquias/save
 *
 * Validates service pricing per franchise. Creates or updates the pricing
 * record for a specific service in a specific franchise.
 */
import { registerContract } from './validate'

export interface ValorServicosFranquias_SaveInput {
franquia_id: number
servico_id: number
servico_valor_padrao: number
servico_valor_minimo: number
}

registerContract('ValorServicosFranquias_SaveInput', {
  franquia_id:          { type: 'number',  required: true },
  servico_id:           { type: 'number',  required: true },
  servico_valor_padrao: { type: 'number',  required: true },
  servico_valor_minimo: { type: 'number',  required: true },
})
